import { render, staticRenderFns } from "./DeleteWorkspaceModal.vue?vue&type=template&id=39e5f20f&"
import script from "./DeleteWorkspaceModal.vue?vue&type=script&lang=js&"
export * from "./DeleteWorkspaceModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports